import { Chip, CircularProgress, Grid, MenuItem, TextField, Tooltip, Typography } from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { Box } from '@material-ui/core';
import AdditionalInfoSection from './AdditionalInfoSection';
import { DropzoneUpload } from './InputsRendered';
import { EmployeeNameField, DateTimeField } from './SharedFormFields';
import moment from 'moment';
import { ALL_TASK_OPTIONS } from './GeneralTaskForm';

const ExpenseClaimForm = ({
  data,
  setData,
  files,
  isLoading,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
  isAdd = false,
}) => {
  const handleChangeData = (name, value) => {
    setData(prev => ({ ...prev, [name]: value }));
  };

  // On Edit, dateAndTime comes from DB and needs moment formatting.
  // On Add, it's already in the correct datetime-local format from state init.
  const dateValue = isAdd ? data['dateAndTime'] || '' : moment(data['dateAndTime']).format('YYYY-MM-DDTHH:mm');

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': { fontSize: '0.825rem' },
        '& .MuiInputBase-root': { fontSize: '0.825rem !important' },
        paddingBottom: '1rem',
      }}>
      {/* Shared fields */}
      <EmployeeNameField value={data['employeeName']} onChange={handleChangeData} />

      {/* Date: pass the formatted value through for Edit, raw for Add */}
      <DateTimeField value={dateValue} onChange={handleChangeData} />

      <InputFields
        label="Cost Incurred"
        name="costIncurred"
        required
        value={data['costIncurred']}
        textFieldType="number"
        width={6}
        multiline
        handleIpChange={handleChangeData}
      />

      <InputFields
        label="Detail of All Repairs/Expenses Incurred"
        name="detailOfAllRepairsExpensesIncurred"
        required
        value={data['detailOfAllRepairsExpensesIncurred']}
        textFieldType="text"
        width={12}
        multiline
        handleIpChange={handleChangeData}
      />

      <Grid item xs={12} sm={12} md={6}>
        <DropzoneUpload label="File Upload" onFileSelect={handleFileChange('files')} multiple />
        <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1, px: 0.5, alignItems: 'center', minHeight: 60 }}>
          {isLoading ? (
            <Box sx={{ display: 'flex' }}>
              <CircularProgress size={22} />
              <Typography style={{ marginLeft: 8 }}>Fetching Docs...</Typography>
            </Box>
          ) : files && files.length > 0 ? (
            files.map((file, index) => (
              <Tooltip title={file.docName} key={index}>
                <div>
                  <Chip
                    label={file?.documentName?.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                    color="success"
                    sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                    onDelete={() => handleDeleteFiles(file)}
                    onClick={() => viewFile && viewFile(file)}
                  />
                </div>
              </Tooltip>
            ))
          ) : (
            <Typography>No files uploaded.</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ExpenseClaimForm;
